<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-danger">
            <h4 class="card-title">{{ isEditMode ? 'Edit Expense' : 'Add Expense' }}</h4>
            <p class="card-category">Complete expense details</p>
          </div>
          <div class="card-body">
            <form [formGroup]="expenseForm" (ngSubmit)="submitForm()">
              <div class="row">

                <!-- Amount -->
                <div class="col-md-4">
                  <mat-form-field class="w-100">
                    <mat-label>Amount</mat-label>
                    <input matInput type="number" formControlName="amount" placeholder="Enter amount" required />
                  </mat-form-field>
                </div>

                <!-- Expense Date -->
                <div class="col-md-4">
                  <mat-form-field class="w-100">
                    <mat-label>Expense Date</mat-label>
                    <input matInput [matDatepicker]="picker" formControlName="expenseDate" placeholder="Choose date" />
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>

              <div class="row">

                <!-- Client -->
                <div class="col-md-4">
                  <mat-form-field class="w-100">
                    <mat-label>Client</mat-label>
                    <mat-select formControlName="clientId">
                      <mat-option *ngFor="let client of clients" [value]="client.id">{{ client.fullName }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <!-- Case -->
                <div class="col-md-4">
                  <mat-form-field class="w-100">
                    <mat-label>Case</mat-label>
                    <mat-select formControlName="caseId">
                      <mat-option *ngFor="let c of cases" [value]="c.id">{{ c.caseNumber }}/{{ c.year }} - {{ c.client?.fullName }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <!-- Diary -->
                <div class="col-md-4">
                  <mat-form-field class="w-100">
                    <mat-label>Diary</mat-label>
                    <mat-select formControlName="diaryId">
                      <mat-option *ngFor="let diary of diaries" [value]="diary.id">{{ diary.hearingDate | date:'shortDate' }} - {{ diary.case?.caseNumber }}/{{ diary.case?.year }} - {{ diary.case?.client?.fullName }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              <!-- Validation Error Message -->
              <div class="row" *ngIf="hasAtLeastOneError()">
                <div class="col-md-12">
                  <div class="text-danger" style="display: flex; align-items: center; margin-top: -10px; margin-bottom: 15px; padding: 8px 12px; background-color: #ffebee; border-left: 4px solid #f44336; border-radius: 4px;">
                    <mat-icon style="font-size: 20px; width: 20px; height: 20px; margin-right: 8px; color: #f44336;">error</mat-icon>
                    <span style="font-size: 14px;">Please select at least one of: Client, Case, or Diary</span>
                  </div>
                </div>
              </div>

              <div class="row">
                <!-- Description -->
                <div class="col-md-12">
                  <mat-form-field class="w-100">
                    <mat-label>Description</mat-label>
                    <textarea matInput formControlName="description" rows="3" placeholder="Optional description"></textarea>
                  </mat-form-field>
                </div>
              </div>

              <button mat-raised-button color="warn" type="submit" class="btn btn-danger pull-right" [disabled]="isSubmited">
                {{ isEditMode ? 'Update Expense' : 'Add Expense' }}
              </button>
              <div class="clearfix"></div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
